import { Component } from '@theme/component';

const STORAGE_KEY = 'trendaze:theme';

// Cuando el modo claro opcional esta activo hay que forzar el fondo del
// header con un estilo en linea, porque Horizon pinta su fila superior con
// un color fijo puesto en linea (style="--color-background-top-row: ...")
// resuelto a partir de la paleta nocturna por defecto -- eso gana siempre a
// cualquier variable de :root por mucha especificidad que tenga, asi que
// solo otro estilo en linea (o JS tocando la misma propiedad) puede
// sobreescribirlo. En nocturno (por defecto) no hace falta tocar nada: el
// valor en linea ya sale correcto de la paleta.
const HEADER_LIGHT_BACKGROUND = 'rgba(255, 255, 255, 1)';

/**
 * @param {boolean} isLight
 */
function applyHeaderOverride(isLight) {
  const header = document.getElementById('header-component');
  if (!header) return;

  if (isLight) {
    header.style.setProperty('--color-background-top-row', HEADER_LIGHT_BACKGROUND);
    header.style.setProperty('--color-background-bottom-row', HEADER_LIGHT_BACKGROUND);
  } else {
    header.style.removeProperty('--color-background-top-row');
    header.style.removeProperty('--color-background-bottom-row');
  }
}

/**
 * El estado inicial (evitar parpadeo al cargar) lo aplica un script en
 * linea en layout/theme.liquid, antes de que se pinte la pagina. Este
 * componente gestiona el click, mantiene sincronizado el boton, y aplica
 * el override del header (ver nota arriba).
 */
export class DarkModeToggleComponent extends Component {
  requiredRefs = ['button'];

  connectedCallback() {
    super.connectedCallback();
    applyHeaderOverride(document.documentElement.getAttribute('data-theme') === 'light');
    this.sync();
  }

  toggle() {
    const isLight = document.documentElement.getAttribute('data-theme') === 'light';
    const next = !isLight;

    if (next) {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }

    applyHeaderOverride(next);

    try {
      if (next) {
        window.localStorage.setItem(STORAGE_KEY, 'light');
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // localStorage no disponible; no se recuerda la preferencia entre sesiones.
    }

    this.sync();
  }

  sync() {
    const isLight = document.documentElement.getAttribute('data-theme') === 'light';
    this.refs.button.setAttribute('aria-pressed', String(isLight));
    this.refs.button.setAttribute(
      'aria-label',
      isLight ? 'Volver al modo nocturno' : 'Cambiar a modo claro'
    );
  }
}

if (!customElements.get('dark-mode-toggle-component')) {
  customElements.define('dark-mode-toggle-component', DarkModeToggleComponent);
}
